import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'stringToArray' })
export class StringToArrayPipe implements PipeTransform {
    transform(value: string, split: string = ''): any {
        return value && typeof value === 'string' ? value.split(split) : [];
    }
}
